<script>
import { authComputed } from '@state/helpers'
import NavBarRoutes from './nav-bar-routes'

export default {
  components: { NavBarRoutes },
  data() {
    return {
      persistentNavRoutes: [
        {
          name: 'property-landing',
          title: 'Home',
        },
        {
          name: 'web-checkin',
          title: 'Web Check-in',
        },
      ],
      loggedInNavRoutes: [
        {
          name: 'member-profile',
          title: 'Profile',
        },
        {
          name: 'member-logout',
          title: 'Log out',
        },
      ],
      loggedOutNavRoutes: [
      {
          name: 'member-register',
          query: {
            redirectFrom: this.$route.fullPath,
          },
          title: 'Register',
        },
        {
          name: 'member-login',
          query: {
            redirectFrom: this.$route.fullPath,
          },
          title: 'Log in',
        },
      ],
    }
  },
  computed: {
    ...authComputed,
  },
}
</script>

<template>
  <ul class="flex text-gold-500 uppercase">
    <NavBarRoutes :routes="persistentNavRoutes" />
    <NavBarRoutes v-if="loggedIn" :routes="loggedInNavRoutes" />
    <NavBarRoutes v-else :routes="loggedOutNavRoutes" />
  </ul>
</template>
